module.exports = __webpack_public_path__ + "static/media/bouquet-xl.8f21218b.svg";